const LocationMap = () => (
  <div style={{ width: '100%', maxWidth: '800px' }}>
    <iframe title="location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2878.5413952209014!2d-79.30499722361104!3d43.82387117109454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4d408626a9ceb%3A0x21cdaa4faef24657!2s4675%20Steeles%20Ave%20E%2C%20Scarborough%2C%20ON%20M1V%200B7!5e0!3m2!1szh-TW!2sca!4v1745037127412!5m2!1szh-TW!2sca" width="100%" height="450" style={{border:0, borderRadius: '0.5rem'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
);

export default LocationMap;